import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ISelfEvaluation } from "../types";
import { ISelfEvaluationResource } from "../types/ISelfEvaluationResource";

export interface ISelfEvaluationQueryParameters {
    selfEvaluation: RelationalValue<ISelfEvaluationResource>;
}

export type ISelfEvaluationQueryResult = ISelfEvaluation;

export const selfEvaluationQuery: IApiQueryFunction<ISelfEvaluationQueryParameters> = ({ selfEvaluation }) => {
    return {
        method: "GET",
        url: `/self_evaluations/${mapRelationalValue(selfEvaluation)}`,
    };
};

export const useSelfEvaluationQuery = createApiQueryHook<ISelfEvaluationQueryParameters, ISelfEvaluationQueryResult>(
    selfEvaluationQuery,
);
